import {
  useMutation,
  useQuery
} from '@tanstack/vue-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query'
import {
  computed,
  unref
} from 'vue'
import type {
  MaybeRef
} from 'vue'
import type {
  BackendErrorEntity,
  SalesPredictionDto,
  StatsEntity
} from '.././types'
import { fetchApiInstance } from '../../fetchApiInstance';
import type { ErrorType, BodyType } from '../../fetchApiInstance';


type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];


export const apiGetSalesPrediction = (
    companyId: MaybeRef<string | undefined | null>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      companyId = unref(companyId);
      
      return fetchApiInstance<StatsEntity[]>(
      {url: `/stats/${companyId}/salesPrediction`, method: 'GET'
    },
      options);
    }
  

export const getApiGetSalesPredictionQueryKey = (companyId: MaybeRef<string | undefined | null>,) => {
    return ['stats',companyId,'salesPrediction'] as const;
    }

    
export const getApiGetSalesPredictionQueryOptions = <TData = Awaited<ReturnType<typeof apiGetSalesPrediction>>, TError = ErrorType<BackendErrorEntity>>(companyId: MaybeRef<string | undefined | null>, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiGetSalesPrediction>>, TError, TData>, request?: SecondParameter<typeof fetchApiInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getApiGetSalesPredictionQueryKey(companyId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiGetSalesPrediction>>> = () => apiGetSalesPrediction(companyId, requestOptions);

      

      

   return  { queryKey, queryFn, enabled: computed(() => !!(unref(companyId))), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiGetSalesPrediction>>, TError, TData> 
}

export type ApiGetSalesPredictionQueryResult = NonNullable<Awaited<ReturnType<typeof apiGetSalesPrediction>>>
export type ApiGetSalesPredictionQueryError = ErrorType<BackendErrorEntity>



export function useApiGetSalesPrediction<TData = Awaited<ReturnType<typeof apiGetSalesPrediction>>, TError = ErrorType<BackendErrorEntity>>(
 companyId: MaybeRef<string | undefined | null>, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiGetSalesPrediction>>, TError, TData>, request?: SecondParameter<typeof fetchApiInstance>}

  ): UseQueryReturnType<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getApiGetSalesPredictionQueryOptions(companyId,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: QueryKey };

  query.queryKey = unref(queryOptions).queryKey as QueryKey;

  return query;
}



export const apiCreateSalesPrediction = (
    salesPredictionDto: MaybeRef<SalesPredictionDto>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      salesPredictionDto = unref(salesPredictionDto);
      
      return fetchApiInstance<StatsEntity>(
      {url: `/stats/salesPredictions`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: salesPredictionDto
    },
      options);
    }
  


export const getApiCreateSalesPredictionMutationOptions = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiCreateSalesPrediction>>, TError,{data: BodyType<SalesPredictionDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiCreateSalesPrediction>>, TError,{data: BodyType<SalesPredictionDto>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiCreateSalesPrediction>>, {data: BodyType<SalesPredictionDto>}> = (props) => {
          const {data} = props ?? {};

          return  apiCreateSalesPrediction(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiCreateSalesPredictionMutationResult = NonNullable<Awaited<ReturnType<typeof apiCreateSalesPrediction>>>
    export type ApiCreateSalesPredictionMutationBody = BodyType<SalesPredictionDto>
    export type ApiCreateSalesPredictionMutationError = ErrorType<BackendErrorEntity>

    export const useApiCreateSalesPrediction = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiCreateSalesPrediction>>, TError,{data: BodyType<SalesPredictionDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof apiCreateSalesPrediction>>,
        TError,
        {data: BodyType<SalesPredictionDto>},
        TContext
      > => {

      const mutationOptions = getApiCreateSalesPredictionMutationOptions(options);

      return useMutation(mutationOptions);
    }
    